import { render, staticRenderFns } from "./StaffTable.vue?vue&type=template&id=d763e47e&scoped=true&"
import script from "./StaffTable.vue?vue&type=script&lang=js&"
export * from "./StaffTable.vue?vue&type=script&lang=js&"
import style0 from "./StaffTable.vue?vue&type=style&index=0&id=d763e47e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d763e47e",
  null
  
)

export default component.exports